var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobilePublicNavigation"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":"LUNA AI"},on:{"click":_vm.scrollTop}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }